<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header d-flex align-items-center">
            <span>Letzte Läufe</span>
            <router-link
              :to="{ name: 'einstellungen-protokoll' }"
              class="zum-protokoll ml-auto mr-1"
              title="Alle Läufe im Protokoll"
            >
              <font-awesome-icon icon="fa-regular fa-chevron-right" />
            </router-link>
          </div>
          <div class="body p-2">
            <ul class="nav nav-tabs reiter">
              <li v-for="f in filterListe" :key="f.key" class="nav-item">
                <a class="nav-link" :class="{ active: filter === f.key }" href="#" @click.prevent="filterWaehlen(f.key)">
                  {{ f.text }}
                </a>
              </li>
            </ul>
            <div class="block belegliste br-t-l-0 p-2">
              <b-table
                small
                hover
                tbody-tr-class="item zeile"
                :items="laeufe"
                :fields="felder"
                primary-key="id"
                show-empty
                empty-text="Keine Läufe"
                @row-clicked="oeffnen"
              >
                <template #cell(zeit)="{ item }">{{ zeitText(item) }}</template>
                <template #cell(ablauf)="{ item }">{{ ablaufText(item) }}</template>
                <template #cell(ausloeser)="{ item }">{{ ausloeserText(item) }}</template>
                <template #cell(ergebnis)="{ item }">
                  <span :class="ergebnisKlasse(item)">{{ ergebnisText(item) }}</span>
                </template>
                <template #cell(zusammenfassung)="{ item }">
                  <span :class="{ 'text-muted': zusammenfassungIstMeldung(item) }">{{ zusammenfassungText(item) }}</span>
                </template>
              </b-table>
            </div>
            <div class="text-right mt-1">
              <router-link :to="{ name: 'einstellungen-protokoll' }">Alle Läufe im Protokoll</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BTable } from "bootstrap-vue";
import {
  ablaufText,
  ausloeserText,
  ergebnisKlasse,
  ergebnisText,
  STATUS_MIT_FEHLERN,
  zusammenfassungIstMeldung,
  zusammenfassungText,
} from "@/components/Lauf/LaufTexte";

/** Anzahl Läufe unter den Kacheln (9.2); der Server liefert Seiten zu 50 */
const ANZAHL = 10;

/** Die Filter mit ihren Parametern für GET lauf/, immer auch die Läufe ohne Änderung */
const FILTER = [
  { key: "alle", text: "Alle", parameter: {} },
  { key: "fehler", text: "Mit Fehlern", parameter: { status: STATUS_MIT_FEHLERN } },
  { key: "hand", text: "Von Hand", parameter: { ausloeser: "knopf", test: "n" } },
];

/**
 * „Letzte Läufe“ neben den Kacheln (9.2, Board „Einstellungen mit neuer Kategorie“): die 10 jüngsten Läufe aller
 * Abläufe. Jede Zeile öffnet die Lauf-Ansicht über den Event-Bus; die Seite bindet dafür <lauf-ansicht /> ein.
 */
export default {
  name: "LetzteLaeufe",
  components: { BTable },
  data() {
    return {
      filter: "alle",
      laeufe: [],
      filterListe: FILTER,
      felder: [
        { key: "zeit", label: "Zeit" },
        { key: "ablauf", label: "Ablauf und Laufart" },
        { key: "ausloeser", label: "Auslöser" },
        { key: "ergebnis", label: "Ergebnis" },
        { key: "zusammenfassung", label: "Zusammenfassung" },
      ],
    };
  },
  created() {
    this.laden();
  },
  methods: {
    ablaufText,
    ausloeserText,
    ergebnisKlasse,
    ergebnisText,
    zusammenfassungIstMeldung,
    zusammenfassungText,
    laden() {
      const filter = FILTER.find((f) => f.key === this.filter);
      const angefragt = this.filter;
      AppApi.get("lauf/", { params: { ...filter.parameter, ohneAenderung: "ja", seite: 0 } })
        .then((response) => {
          // Eine Antwort zu einem inzwischen gewechselten Filter verwerfen
          if (angefragt !== this.filter) return;
          this.laeufe = response.data.laeufe.slice(0, ANZAHL);
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });
    },
    filterWaehlen(key) {
      if (this.filter === key) return;
      this.filter = key;
      this.laden();
    },
    oeffnen(lauf) {
      this.$bus.$emit("lauf-ansicht-oeffnen", { lauf: lauf.id });
    },
    /** Uhrzeit, bei einem Lauf vor heute Datum und Uhrzeit */
    zeitText(lauf) {
      const [datum, uhrzeit] = (lauf.angefordertAm || "").split(" ");
      return datum === new Date().toGermanDateString() ? uhrzeit : lauf.angefordertAm;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors";

.zum-protokoll {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: $dark-blue;
  color: #fff;
  font-size: 14px;
}
::v-deep .zeile {
  cursor: pointer;
}
.text-bernstein {
  color: #a54800;
  font-weight: 600;
}
.text-rot {
  color: #ae2e24;
  font-weight: 600;
}
</style>
